(() => {
  'use strict';

  const REVEAL_ROOT_SELECTOR = '.spirit-home__section:not(.spirit-hero), .spirit-footer';
  const TARGET_SELECTOR = [
    '.spirit-products__heading',
    '.spirit-products__grid > .spirit-product-card',
    '.spirit-products__link',
    '.spirit-products__note',
    '.spirit-home-quote__composition',
    '.spirit-treatments__panel',
    // Translating rail children creates vertical overflow and a second swipe axis.
    // Keep treatment cards visible and stationary while the rail scrolls.
    '.spirit-treatments__controls',
    '.spirit-collection-story__header',
    '.spirit-collection-story__grid > .spirit-collection-card',
    '.spirit-section-heading',
    '.spirit-testimonials__grid > .spirit-testimonial',
    '.spirit-community-card',
    '.spirit-footer__layout',
    '.spirit-footer__bottom',
  ].join(',');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canObserve = 'IntersectionObserver' in window;
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
  let observer;

  const reveal = (element) => {
    element.classList.add('is-visible');

    const finish = (event) => {
      if (event.propertyName !== 'opacity') return;

      element.removeEventListener('transitionend', finish);
      element.classList.remove('spirit-scroll-reveal', 'is-visible');
      element.style.removeProperty('--spirit-reveal-delay');
    };

    element.addEventListener('transitionend', finish);
  };

  const getObserver = () => {
    if (observer) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);
          reveal(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: '0px 0px -7% 0px',
      }
    );

    return observer;
  };

  const getSections = (root) => {
    const sections = [];

    if (root instanceof Element && root.matches(REVEAL_ROOT_SELECTOR)) {
      sections.push(root);
    }

    root.querySelectorAll(REVEAL_ROOT_SELECTOR).forEach((section) => sections.push(section));
    return sections;
  };

  const prepare = (root = document) => {
    if (reduceMotion.matches || !canObserve || isDesignMode) return;

    const sections = getSections(root);
    if (!sections.length) return;

    document.body.classList.add('spirit-scroll-reveal-ready');
    const activeObserver = getObserver();

    sections.forEach((section) => {
      const targets = Array.from(section.querySelectorAll(TARGET_SELECTOR));

      targets.forEach((element) => {
        if (element.dataset.spiritRevealReady === 'true') return;

        const siblings = Array.from(element.parentElement.children).filter((sibling) =>
          sibling.matches(TARGET_SELECTOR)
        );
        const siblingIndex = Math.max(0, siblings.indexOf(element));
        const staggerIndex = Math.min(siblingIndex, 5);

        element.dataset.spiritRevealReady = 'true';
        element.style.setProperty('--spirit-reveal-delay', `${staggerIndex * 70}ms`);
        element.classList.add('spirit-scroll-reveal');
        activeObserver.observe(element);
      });
    });
  };

  const initialize = () => prepare(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
